const CardSuspendReasons= {
    LOST : 'LOST',
    DAMAGED : 'DAMAGED',
    STOLEN : 'STOLEN',
    OTHER:'OTHER'
};

export default CardSuspendReasons;

